/**
 * Landowner Insurance Terms version constants.
 * Bump VERSION whenever the terms body changes after legal review.
 * Keep in sync with server/api-util/landownerInsuranceTerms.js
 */
export const LANDOWNER_INSURANCE_TERMS_VERSION = '1.0.0';
export const LANDOWNER_INSURANCE_TERMS_LAST_UPDATED = 'July 27, 2026';
